module.exports = __webpack_public_path__ + "static/media/Hero.2c6ee5ad.png";